import { createCollection } from '@rocketlane/state-db';
import { TimesheetAPI } from 'api/timesheets';
import { TimesheetSourcePage } from 'api/timesheets/types';
import { TimesheetStatus } from 'components/organisms/timesheets/types';
const resolveOriginal = (ctx)=>{
    if (!ctx.original) {
        throw new Error(`timesheetCollection: no original for key ${String(ctx.id)} — ensure the entity is pushed before mutating`);
    }
    return ctx.original;
};
const routeUpdate = async (ctx)=>{
    var _ctx_metadata, _meta_sourcePage;
    var _ctx_changes;
    const original = resolveOriginal(ctx);
    const { userId, startDate, updatedAt } = original;
    const meta = (_ctx_metadata = ctx.metadata) !== null && _ctx_metadata !== void 0 ? _ctx_metadata : {};
    const sourcePage = (_meta_sourcePage = meta.sourcePage) !== null && _meta_sourcePage !== void 0 ? _meta_sourcePage : TimesheetSourcePage.MyTimesheet;
    const { projectId, timeEntryIds, rejectNote } = meta;
    switch((_ctx_changes = ctx.changes) === null || _ctx_changes === void 0 ? void 0 : _ctx_changes.status){
        case TimesheetStatus.Approved:
            return TimesheetAPI.approveTimesheet(userId, startDate, updatedAt, sourcePage, projectId, timeEntryIds);
        case TimesheetStatus.Submitted:
            return TimesheetAPI.submitTimesheet(userId, startDate, sourcePage, projectId, timeEntryIds);
        case TimesheetStatus.Rejected:
            return TimesheetAPI.rejectTimesheet(userId, startDate, updatedAt, sourcePage, rejectNote, projectId, timeEntryIds);
        case TimesheetStatus.NotSubmitted:
            // Withdrawal (approver withdrawing from Approved/Submitted → NotSubmitted).
            // For submitter-initiated unsubmit use `unsubmitTimesheetRecord` in actions.ts.
            return TimesheetAPI.withdrawTimesheet(userId, startDate, sourcePage, projectId, timeEntryIds);
        case undefined:
            var _ctx_changes1;
            throw new Error(`timesheetCollection: unhandled status transition to ${String((_ctx_changes1 = ctx.changes) === null || _ctx_changes1 === void 0 ? void 0 : _ctx_changes1.status)} for ${String(ctx.id)}`);
    }
};
export const timesheetCollection = createCollection({
    id: 'timesheets',
    getKey: (t)=>{
        var _ref;
        var _t_project;
        return `${t.userId}_${t.startDate}_${(_ref = (_t_project = t.project) === null || _t_project === void 0 ? void 0 : _t_project.id) !== null && _ref !== void 0 ? _ref : 0}`;
    },
    indexes: {
        byUser: (t)=>t.userId,
        byStatus: (t)=>t.status
    },
    // Use updatedAt for optimistic concurrency — a WS push that arrives while an
    // optimistic edit is in flight should not clobber the newer overlay.
    isNewer: (incoming, existing)=>incoming.updatedAt >= existing.updatedAt,
    onUpdate: routeUpdate
});
/** Composite key used by callers that need to read/watch a specific user-week-project. */ export const timesheetKey = (userId, startDate, projectId = 0)=>`${userId}_${startDate}_${projectId}`;
/** Imperative read of a specific user-week-project from the collection. */ export const getTimesheetFromCollection = (userId, startDate, projectId = 0)=>timesheetCollection.get(timesheetKey(userId, startDate, projectId));
/** Imperative read of all weeks currently loaded for a user. */ export const getTimesheetsForUserFromCollection = (userId)=>timesheetCollection.getByIndex('byUser', userId);
